import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compileProgram } from "../../actions/compile";
import { Link } from "react-router-dom";

const Problem = ({
  problem: {
    _id,
    que_no,
    title,
    description,
    category,
    difficulty,
    constraint,
    example_input,
    example_output,
    time_limit,
    memory_limit,
  },
  compileProgram,
}) => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <div className="row" style={{ backgroundColor: "white" }}>
        <div className="col-md-6 col-sm-6">
          {que_no}. {title}
        </div>
        <div className="col-md-2 col-sm-2 ml-3">
          <Link
            to={`/problems/${_id}`}
            style={{ color: "blue", textDecorationLine: "none" }}
          >
            Solve
          </Link>
        </div>
        <div className="col-md-2 col-sm-2 ml-3">
          {difficulty === "Easy" && (
            <span style={{ color: "rgb(44, 99, 44)" }}>Easy</span>
          )}
          {difficulty === "Medium" && (
            <span style={{ color: "rgb(211, 150, 36)" }}>Medium</span>
          )}
          {difficulty === "Hard" && (
            <span style={{ color: "rgb(188, 34, 34)" }}>Hard</span>
          )}
        </div>
      </div>

      <hr />
    </div>
  );
};

Problem.propTypes = {
  problem: PropTypes.object.isRequired,
};

export default connect(null, { compileProgram })(Problem);
